import React, { useContext, useEffect, useRef, useState } from 'react';
import { STWContext } from '../../widgets/STW/context';
import CountriesDropDown from '../countryCodePicker/countriesDropdown';
import SelectedCountry from '../selectedCountry/selectedCountry';
import { IUserFields } from '../userDetailsForm/userDetailsForm';
import InfoIcon from '../../assets/svg/info';
import { InputProps } from '../WhatsappInput/whatsappInput';
import { LanguageUtils } from '../../utilities/languageUtilities';

const SMSInput: React.FC<InputProps> = ({
  selectedCountryData,
  fontColour,
  setUserInputs,
  onChangeHandle,
  value,
  title = 'Sms Number',
  error,
  skipLabel,
  skipCountryPicker,
  id,
  size,
  onFocusColour,
  onBlur,
  widgetLanguage,
}) => {
  const languageUtilities = new LanguageUtils();
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const { preview, isMobile } = useContext(STWContext);
  const [currentStyle, setCurrentStyle] = useState<any>(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const importStyles = async () => {
      let stylesModule;
      if (preview) {
        if (isMobile) {
          stylesModule = await import(
            '../WhatsappInput/whatsappInputPreviewMobile.module.css'
          );
        } else {
          stylesModule = await import(
            '../WhatsappInput/whatsappInputPreviewDesktop.module.css'
          );
        }
      } else {
        stylesModule = await import(
          '../WhatsappInput/whatsappInput.module.css'
        );
      }
      setCurrentStyle(stylesModule.default);
    };
    importStyles().then();
  }, [preview, isMobile]);

  const toggleDropDown = (flag: boolean) => {
    setShowDropdown(flag);
  };
  const onListItemClickHandle = (code: string, dial: string, code3: string) => {
    setUserInputs(prevState => {
      return {
        ...prevState,
        isSms: {
          ...prevState.isSms,
          countryCodeData: { code, dial, code3 },
        },
      };
    });
    toggleDropDown(false);
  };
  if (!currentStyle) {
    return <></>;
  }
  return (
    <div
      className={
        currentStyle.bikStwPhoneInputRow + ' ' + currentStyle.bikInputMain
      }
    >
      {!skipCountryPicker && (
        <div style={{ fontFamily: 'inherit' }}>
          {!skipLabel && (
            <h2 className={currentStyle.bikStwH2} style={{ color: fontColour }}>
              {languageUtilities.getCountryPlaceholder(widgetLanguage)}
            </h2>
          )}
          <SelectedCountry
            fontColour={fontColour}
            toggleDropDown={toggleDropDown}
            showDropdown={showDropdown}
            selectedCountryData={selectedCountryData}
            size={size}
          />
          {showDropdown && (
            <CountriesDropDown
              onListItemClickHandle={onListItemClickHandle}
              closeDropdown={() => {
                setShowDropdown(false);
              }}
            />
          )}
        </div>
      )}
      <div className={currentStyle.bikStwPhoneInput}>
        {!skipLabel && (
          <h2 className={currentStyle.bikStwH2} style={{ color: fontColour }}>
            {title}
          </h2>
        )}
        <div className={currentStyle.bikInputWrapper}>
          <input
            id={id}
            ref={inputRef}
            onBlur={() => {
              if (onFocusColour) {
                inputRef.current.style.border = `1px solid #e0e0e0`;
              }
              onBlur('isSms');
            }}
            onFocus={() => {
              if (onFocusColour) {
                inputRef.current.style.border = `1px solid ${onFocusColour}`;
              }
            }}
            className={currentStyle.bikStwSpinInputText}
            style={
              size === 'small' || preview
                ? { color: fontColour }
                : { height: 48, color: fontColour }
            }
            type="number"
            placeholder={languageUtilities.getPhoneNumberPlaceholder(
              widgetLanguage,
            )}
            onChange={e => onChangeHandle(e.target.value, 'isSms')}
            value={value}
          />
          {error && (
            <div
              className={currentStyle.bikStwError}
              style={{ color: fontColour }}
            >
              <InfoIcon />
              <div>{' ' + error}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SMSInput;
